import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";

import { Usuario } from "../usuario/usuario";
import { PerfilAcesso } from "../usuarios/perfis-acesso";
//import { Usuarios } from './usuarios';
import { UsuariosService } from "../usuarios/usuarios.service";
import { AuthAndACLService } from "../auth_and_acl/authAndACL.service";
//import { PerfilService } from '../perfil/perfil.service';

@Component({
  selector: "app-editar-usuarios",
  templateUrl: "./editar-usuarios.component.html",
  styleUrls: ["./editar-usuarios.component.css"],
  providers: [UsuariosService, AuthAndACLService]
})
export class EditarUsuariosComponent implements OnInit {
  usuario: Usuario;
  perfil: PerfilAcesso;
  perfis: PerfilAcesso[];
  array_perfis_usuario = new Array();
  usuario_logado = new Array();

  constructor(
    private usuariosService: UsuariosService,
    private route: ActivatedRoute,
    private router: Router,
    private authAndACL: AuthAndACLService
  ) {
    this.usuario = new Usuario();
    this.perfil = new PerfilAcesso();
    this.usuario_logado = this.authAndACL.getUserData();
  }

  obterDadosUsuario() {
    //console.log('usuario logado:');
    //console.log(this.usuario_logado);
    this.usuariosService.getPerfisAcesso().then(perfil => {
      this.perfis = perfil["dados"];
      //console.log(this.perfis);
    });

    this.route.params.forEach((params: Params) => {
      let id = params["id"];

      if (id !== undefined) {
        this.usuariosService
          .getUsuario(id)
          .then(usuario => {
            this.usuario = usuario["dados"];
            //this.array_perfis_usuario = this.usuario.perfis;

            for (let id_perfil of this.usuario.perfis) {
              this.array_perfis_usuario.push(id_perfil["id"]);
            }

            //console.log(this.usuario);
            //console.log(this.array_perfis_usuario);
            //console.log(this.usuario.perfil_ids[1]);
          })
          .catch(() => this.goBack());
      }
    });
  }

  salvarDadosUsuario(): void {
    this.usuario.perfil_ids = this.array_perfis_usuario;
    //console.log(this.array_perfis_usuario);
    //console.log(this.usuario);
    this.usuariosService.saveUsuario(this.usuario)
    .then(() => this.goBack())
    .catch(erro => alert('ERRO!'));
    /*if (this.usuariosService.saveUsuario(this.usuario) !== undefined) {
      //console.log('salvo!!');
      if (this.usuario_logado['id'] === this.usuario.id) {
        alert("Para que as suas alterações sejam concluídas será necessário se logar no sistema novamente.");
        //console.log('deslogando usuario');
        //this.authAndACL.logout();
      }
      else {
        this.goBack();
      }
    }*/
  }

  addPerfilUsuario(e) {
    if (e.target.checked) {
      //console.log(e);
      const index: number = this.array_perfis_usuario.indexOf(
        parseInt(e.target.value)
      );
      if (index == -1) {
        this.array_perfis_usuario.push(parseInt(e.target.value));
      }
    } else {
      const index: number = this.array_perfis_usuario.indexOf(
        parseInt(e.target.value)
      );
      if (index !== -1) {
        this.array_perfis_usuario.splice(index, 1);
      }
    }
    //console.log(this.array_perfis_usuario);
  }

  ngOnInit() {
    this.obterDadosUsuario();
  }

  goBack(): void {
    this.router.navigate(["usuarios"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/editar-usuarios/editar-usuarios.component.ts